import { render, staticRenderFns } from "./passenger.vue?vue&type=template&id=59096fdc&scoped=true"
import script from "./passenger.vue?vue&type=script&lang=js"
export * from "./passenger.vue?vue&type=script&lang=js"
import style0 from "./passenger.vue?vue&type=style&index=0&id=59096fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59096fdc",
  null
  
)

export default component.exports